import { Search, X } from 'lucide-react';
import type { ReactNode } from 'react';
import './LiksSearch.css';

export type LiksSearchVariant = 'on-dark' | 'on-light';

export type LiksSearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  clearLabel: string;
  variant?: LiksSearchVariant;
  className?: string;
  leadingIcon?: ReactNode;
  'aria-label': string;
};

export function LiksSearch({
  value,
  onChange,
  placeholder,
  clearLabel,
  variant = 'on-dark',
  className,
  leadingIcon,
  'aria-label': ariaLabel,
}: LiksSearchProps) {
  const showClear = value.length > 0;

  const handleClear = () => {
    onChange('');
  };

  return (
    <div
      className={['liks-search', `liks-search--${variant}`, className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="liks-search__field">
        {leadingIcon ?? (
          <Search className="liks-search__icon" strokeWidth={2} aria-hidden />
        )}
        <input
          type="text"
          className="liks-search__input"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          aria-label={ariaLabel}
        />
      </div>
      {showClear && (
        <button
          type="button"
          className="liks-search__clear"
          aria-label={clearLabel}
          onClick={handleClear}
        >
          <X className="liks-search__clear-icon" strokeWidth={3} aria-hidden />
        </button>
      )}
    </div>
  );
}
